import type { RouteRecordRaw } from 'vue-router'
import { createRouter, createWebHashHistory } from 'vue-router'
import NotFoundPage from '@/404.vue'
import { useUserStore } from '@/store/user'

const constantRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/chat',
    name: 'Chat',
    component: () => import('@/views/intelligence/chat.vue'),
    meta: { title: '聊天' }
  },
  {
    path: '/',
    name: 'Layout',
    component: () => import('@/layout/index.vue'),
    redirect: () => {
      const path = useUserStore().menus?.[0]?.path
      if (path) return path
      if (localStorage.getItem('token')) {
        ElMessage.error('该用户暂未配置权限')
        localStorage.clear()
      }
      return '/login'
    },
    children: [
      {
        path: 'organization/user/profile',
        name: 'UserProfile',
        component: () => import('@/views/organization/user/profile.vue'),
        meta: { title: '个人中心' }
      }
    ]
  }
]

const notFoundRoute = {
  path: '/:pathMatch(.*)*',
  name: 'NotFound',
  component: NotFoundPage,
  meta: { title: '404', hidden: true }
}

const router = createRouter({
  history: createWebHashHistory(),
  routes: constantRoutes
})

const modules = import.meta.glob('../views/**/*.vue')

let isDynamicRoutesAdded = false

export function generateRoutes(menus: any[]) {
  const routes: RouteRecordRaw[] = []

  const parseMenu = (menuList: any[]) => {
    for (const menu of menuList) {
      if (menu.path) {
        // Remove leading slash for matching file path correctly
        const pathStr = menu.path.startsWith('/') ? menu.path.substring(1) : menu.path

        // Find matching component in views
        const component = modules[`../views/${pathStr}.vue`]
          || modules[`../views/${pathStr}/index.vue`]

        routes.push({
          path: menu.path,
          name: menu.path.replace(/\//g, '_'),
          component,
          meta: { title: menu.code || menu.name, icon: menu.icon }
        })
      }

      if (menu.children && menu.children.length > 0) {
        parseMenu(menu.children)
      }
    }
  }

  parseMenu(menus)
  return routes
}

export function addDynamicRoutes() {
  if (isDynamicRoutesAdded) return true
  const userStore = useUserStore()
  if (!userStore.menus || userStore.menus.length === 0) return false

  const dynamicRoutes = generateRoutes(userStore.menus)
  dynamicRoutes.forEach((route) => {
    router.addRoute('Layout', route)
  })
  // 必须在此处追加,不然会导致404覆盖动态路由
  router.addRoute('Layout', notFoundRoute)
  isDynamicRoutesAdded = true
  return true
}

export function resetDynamicRoutes() {
  isDynamicRoutesAdded = false
}

// Route guard
router.beforeEach((to, _, next) => {
  const userStore = useUserStore()
  if (to.path !== '/login' && !userStore.token) {
    next('/login')
  } else if (to.path === '/login' && userStore.token) {
    next('/')
  } else {
    // try to add dynamic routes if logged in
    if (userStore.token && !isDynamicRoutesAdded) {
      const added = addDynamicRoutes()
      if (added) {
        return next({ ...to, replace: true })
      }
    }
    next()
  }
})

export default router
